(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDialogController', PublicSiteLanguageDialogController);

    PublicSiteLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteLanguage.id !== null) {
                PublicSiteLanguage.update(vm.publicSiteLanguage, onSaveSuccess, onSaveError);
            } else {
                PublicSiteLanguage.save(vm.publicSiteLanguage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
